import React from "react";

const WriteYourself = ({ width = "14", height = "14", color = "#919293" }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.12994 1.6001C3.81874 1.6043 2.60794 1.6613 1.83454 2.4341C0.999939 3.2699 0.999939 4.6133 0.999939 7.3001C0.999939 9.9869 0.999939 11.3303 1.83454 12.1655C2.66974 13.0001 4.01254 13.0001 6.70054 13.0001C9.38735 13.0001 10.7307 13.0001 11.5653 12.1655C12.3393 11.3915 12.3957 10.1813 12.3999 7.8695"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.43343 7.60009C5.99903 2.11969 9.88103 0.565689 12.9878 1.09849C13.1132 2.91469 12.224 3.59449 10.532 3.90889C10.859 4.25089 11.4362 4.68049 11.3738 5.21689C11.3294 5.59969 11.0702 5.78689 10.5506 6.16249C9.41303 6.98449 8.09543 7.50289 6.43343 7.60009Z"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.20117 9.99986C6.40117 6.69986 7.57717 5.58145 8.80117 4.59985"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default WriteYourself;
